import { useQuery, UseQueryResult } from "react-query";
import { createUrl } from "../../utils/UrlUtils";
import { ApiRoutes } from "../../constants/ApiRoutes";
import { httpClient } from "../../api-legacy/BaseApi";
import { formatResponse } from "../../utils/FormatUtils";

interface Query {
  readonly id: number;
}
export function useAppointmentActionsLogQuery(query: Query): UseQueryResult<any, Error> {
  return useQuery(
    ["appointment-item-history"],
    () =>
      httpClient.get(createUrl(ApiRoutes.appointmentHistoryItem, { query })).then(formatResponse),
    { enabled: query.id > 0 },
  );
}
